module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/27.3fdd3f36.png";